
import axios from 'axios'

const registerApiMail = axios.create({
    baseURL: 'https://api360.360margaritaca.com.ve'
})


export default registerApiMail


